
export const addConfig = {
    clientId: '8b31305e-7a2a-4f9b-b110-dbea998f7a10',
    TenantId: 'feab5e46-2c71-473a-b616-a12a9aeefede'
};


